module.exports = __webpack_public_path__ + "img/IM.6092b74d.png";